<script setup>
import { useRoute } from "vue-router";
import { computed } from "vue";
import SubAppNavigationIcon from "../icons/SubAppNavigationIcon.vue";
const route = useRoute();

const props = defineProps({
  filteredLinks: {
    type: Array,
    required: false,
    default: () => [],
  },
});
const subApp = computed(() => {
  return props.filteredLinks || [];
});
</script>

<template>
  <div class="relative inline-block group">
    <button class="flex items-center justify-center px-4 py-2">
      <SubAppNavigationIcon />
    </button>

    <div
      class="absolute right-0 w-96 bg-white border border-gray-200 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition duration-300 z-10"
    >
      <ul class="p-5">
        <li v-for="(item, index) in subApp" :key="index" class="hover:bg-purple-50 rounded-lg">
          <router-link
            :to="{ name: item.route }"
            class="flex items-center px-4 py-2 w-full block rounded-lg"
            :class="route.name === item.route ? 'bg-blue-440' : 'hover:bg-purple-50'"
          >
            <component :is="item.icon" />
            <span class="pl-2 text-university-primary font-semibold">{{ item.label }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
